import {Messages} from '../../constants';

const validation = {
  tipo: {
    presence: {
      message: Messages.RequiredTypeProfessionValidationMessage,
      allowEmpty: false,
    },
  },
  nome: {
    presence: {
      message: Messages.RequiredProfessionValidationMessage,
      allowEmpty: false,
    },
  },
  rendaMensal: {
    presence: {
      message: Messages.RequiredMonthlyIncomeValidationMessage,
      allowEmpty: false,
    },
  },
  admissao: {
    brDate: {
      message: Messages.InvalidAdmissionDateMessage,
    },
    lowestCurrentDate: {
      message: Messages.LowestCurrentDateAdmissionValidationMessage,
    },
  },
};

export default validation;
